import { gql } from "@apollo/client";

export default gql`
    query sync_block_map($master_block_id: Int!) {
        worksheet_sync_block_map(
            where: { master_block_id: { _eq: $master_block_id } }
        ) {
            id
            master_block_id
            sync_block_ids
        }
    }
`;
